import { createGlobalState } from '@vueuse/core';
import { controlDeferred } from '@eureka/utils/control';
import { packageInfoDeferred, getIfHasTrialPackage } from '@eureka/utils/package-info';
import { computed, onBeforeMount, ref } from 'vue';
import type { EditionControl } from '../types';

export const useEditionControl = createGlobalState(() => {
  const editionControl = ref<EditionControl>({} as EditionControl);

  async function fetchControl() {
    const [res, packages] = await Promise.all([
      controlDeferred.promise,
      packageInfoDeferred.promise,
    ]);
    editionControl.value = {
      is_first_login_after_try_end: res.is_first_login_after_try_end,
      try_package_left_days: res.try_package_left_days,
      trial: getIfHasTrialPackage(packages),
      expired_packages: res.expired_packages || [],
      freemium: res.freemium,
    };
    return res;
  }

  onBeforeMount(() => {
    fetchControl();
  });

  // 是否付费版
  const isAirPremium = computed(() => {
    return !editionControl.value.freemium && !editionControl.value.trial;
  });

  const isFreemium = computed(() => {
    return editionControl.value.freemium;
  });

  const isTrial = computed(() => {
    return editionControl.value.trial;
  });

  return {
    editionControl,
    isAirPremium,
    isFreemium,
    isTrial,
  };
});
